import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation updateUser(
    $idx: Int!
    $name: String
    $phone: String
    $parent_name: String
    $parent_phone: String
    $school_name: String
    $school_grade: String
    $memo: String
    $department: String
    $birthday: String
    $english_name: String
    $address: String
    $deleted_working_days: String
    $working_hour: String
    $current_salary: String
    $date_of_entry: String
    $resident_reg_no: String
    $account_number: String
    $academic_background: String
    $marital_status: String
    $children: String
    $blood_type: String
    $report_income: String
    $special_category: String
    $email: String
    $pw: String
    $lexile_level: String
    $study_access_available: String
    $levelup_test_type: String
  ) {
    updateUser(
      idx: $idx
      name: $name
      phone: $phone
      parent_name: $parent_name
      parent_phone: $parent_phone
      school_name: $school_name
      school_grade: $school_grade
      memo: $memo
      department: $department
      birthday: $birthday
      english_name: $english_name
      address: $address
      deleted_working_days: $deleted_working_days
      working_hour: $working_hour
      current_salary: $current_salary
      date_of_entry: $date_of_entry
      resident_reg_no: $resident_reg_no
      account_number: $account_number
      academic_background: $academic_background
      marital_status: $marital_status
      children: $children
      blood_type: $blood_type
      report_income: $report_income
      special_category: $special_category
      email: $email
      pw: $pw
      lexile_level: $lexile_level
      study_access_available: $study_access_available
      levelup_test_type: $levelup_test_type
    ) {
      idx
      id
      name
      english_name
      school_name
      school_grade
      email
      phone
      memo
      birthday
      parent_name
      parent_phone
      address
      deleted_working_days
      working_hour
      current_salary
      date_of_entry
      resident_reg_no
      account_number
      academic_background
      marital_status
      children
      blood_type
      report_income
      special_category
      type
      campus_idx
      department
      idate
      lexile_level
      study_access_available
      class_student {
        idx
        class {
          idx
          name
        }
      }
    }
  }
`;

export const UPDATE_USER_FOR_LEVEL_TEST = gql`
  mutation registerLevelTestUser($user_idx: Int!, $id: String!, $password: String!, $class_idx: Int!) {
    registerLevelTestUser(user_idx: $user_idx, id: $id, password: $password, class_idx: $class_idx) {
      id
      idx
    }
  }
`;

export const UPDATE_USER_SERVER_SAVED_DATA = gql`
  mutation updateUserServerSavedData($idx: String!, $data: JSONObject!) {
    updateUserServerSavedData(idx: $idx, data: $data)
  }
`;
